// import iColumn from "../../../components/Column.vue";
import iTable from "../../../components/Table.vue";
import IPagination from "../../../components/pagination.vue";

export default {
  name: "roleManagement",
  components: { iTable, IPagination },
  data() {
    return {
      dialogVisible: false,
      height: '550',
      list: [], 
      option: {
        stripe: true, 
        border: true,
        loading: false, 
        highlightCurrentRow: false, 
        mutiSelect: true, 
        serialNumber: true, 
      },
      columns: [
        {
          prop: "name",
          label: this.$t('PlatformSettings.roleName'),
          align: "center",
          width: "460",
        },
        {
          prop: "roleUserNum",
          label: this.$t('PlatformSettings.roleUserNum'),
          align: "center",
          width: "140",
          render: (h, params) => {
            return h('el-tag', {
              on: {
                click: () => {
                  this.cellClick(params)
                }
              }
            }, params.row.roleUserNum)
          }
        },
        {
          prop: "createTime",
          label: this.$t('common.setUpTime'),
          align: "center",
          width: "360",
        },
        {
          prop: "updateTime",
          label: this.$t('common.updateTime'),
          align: "center",
          width: "360",
        },
        {
          prop: "lastUser",
          label: this.$t('common.lastUser'),
          align: "center",
          width: "240",
        },
      ],
      operates: {
        width: 60,
        fixed: "right",
        list: [
          {
            id: '1',
            show: true,
            icon: 'iconfont iconicon-chakanxq',
            plain: true,
            disabled: false,
            method: (index, row) => {
              this.checkKeys = []
              this.appCheckKeys = []
              if (row.menu) {
                row.menu.split(',').map(item => {
                  this.checkKeys.push(item)
                })
              }
              if(row.appMenu) {
                row.appMenu.split(',').map(items => {
                  this.appCheckKeys.push(items)
                })
              }
              this.$nextTick(() => {
                this.$refs.treeData.setCheckedKeys(this.checkKeys)
                this.$refs.appTreeData.setCheckedKeys(this.appCheckKeys)
              })

              this.dialogVisibleTree = true
              this.getTreeMenu()
              this.getAppTreeMenu()
            }
          }
        ],
      },
      currentPage: 1, 
      pageSize: 10, 
      total: 1, 
      dialogFormVisible: false,
      formLabelWidth: '100px',
      diaTitle: '',
      btnType: '',
      rules: {
        name: [
          { required: true, message: this.$t('PlatformSettings.form.roleName'), trigger: 'blur' }
        ],
      },
      form: {
        name: '',
        menu: '',
        appMenu: ''
      },
      data: [],
      appData: [],
      treeData: [],
      appTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'zhName',
        disabled: "disabled"
      },
      roleId: '',
      checkKeys: [],
      appCheckKeys: [],
      dialogVisibleTree: false,
      selected: []
    };
  },
  created() {
    this.getMenu()
    this.getAppMenu()
  },
  mounted() {
    this.getRole()
  },
  methods: {
    cellClick(val) {
      console.log(val)
      this.$router.push({ name: "userManagement", params: { id: val.row.id, name: val.row.name } })
    },
    getRole() {
      let param = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.$store.dispatch('roleManagement/GET_QUERYPAGE', param).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.list = res.data.data.list
            this.$refs.page.CommandTotal = res.data.data.total
          }
        }
      })
    },
    getMenu() {
      this.$store.dispatch('tree/GET_GETMENUNODE', {}).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.data = res.data.data
          }
        }
      })
    },
    getAppMenu() {
      this.$store.dispatch('tree/GET_GETAPPMENUNODE', {}).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.appData = res.data.data
          }
        }
      })
    },
    getTreeMenu() {
      this.$store.dispatch('tree/GET_GETMENUNODE', {}).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.treeData = res.data.data
            this.treeData.map(item => {
              item.disabled = true
              if (item.children) {
                item.children.map(k => {
                  k.disabled = true
                  if(k.children) {
                    k.children.map(n => {
                      n.disabled = true
                    })
                  }
                })
              }
            })
          }
        }
      })
    },
    getAppTreeMenu() {
      this.$store.dispatch('tree/GET_GETAPPMENUNODE', {}).then(res => {
        if (res) {
          if (res.data.code == 200) {
            this.appTreeData = res.data.data
            this.appTreeData.map(item => {
              item.disabled = true
              if (item.children) {
                item.children.map(k => {
                  k.disabled = true
                  if(k.children) {
                    k.children.map(n => {
                      n.disabled = true
                    })
                  }
                })
              }
            })
          }
        }
      })
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getRole();
    },
    addRole() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.add')
      this.btnType = 'add'
      this.checkKeys = []
      this.appCheckKeys = []
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.checkKeys)
        this.$refs.appTree.setCheckedKeys(this.appCheckKeys)
        this.$refs.form.resetFields()
      })
      
    },
    editRole() {
      this.dialogFormVisible = true;
      this.diaTitle = this.$t('common.btn.edit')
      this.btnType = 'edit'
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
        this.form.name = this.selected[0].name
        this.form.menu = this.selected[0].menu
        this.form.appMenu = this.selected[0].appMenu
        this.checkKeys = []
        this.appCheckKeys = []
        if (this.form.menu) {
          var txt = this.selected[0].menu.split(',')
          txt.map((item, index) => {
            this.checkKeys.push(item)
          })
          this.$refs.tree.setCheckedKeys(this.checkKeys)
        }
        if (this.form.appMenu) {
          var appTxt = this.selected[0].appMenu.split(',')
          appTxt.map((items, index) => {
            console.log(items)
            this.appCheckKeys.push(items)
          })
          this.$refs.tree.setCheckedKeys(this.checkKeys)
          this.$refs.appTree.setCheckedKeys(this.appCheckKeys)
        }
      })

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            name: this.form.name,
            menu: this.$refs.tree.getCheckedKeys().join(','),
            appMenu: this.$refs.appTree.getCheckedKeys().join(',')
          }
          console.log(param)
          if (this.btnType == 'add') {
            this.$store.dispatch('roleManagement/GET_INSERTROLE', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('PlatformSettings.form.addRoleSuccess'))
                this.dialogFormVisible = false;
                this.getRole();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => { })

          } else {
            param.id = this.selected[0].id
            this.$store.dispatch('roleManagement/GET_UPDATEROLE', param).then(res => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('PlatformSettings.form.editRoleSuccess'))
                this.dialogFormVisible = false;
                this.getRole();
                this.closeDia();
              } else {
                this.$message.error(res.data.msg)
              }
            }).catch(err => { })
          }
        } else {
          return false;
        }
      });
    },
    cancle(formName) {
      this.dialogFormVisible = false;
      this.form = {
        name: '',
        menu: '',
        appMenu: ''
      }
    },
    closeDia() {
      this.form = {
        name: '',
        menu: '',
        appMenu: ''
      }
      this.dialogFormVisible = false;
    },

    handleCloseTree() {
      this.dialogVisibleTree = false
    },
    deleteRole() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'),
        {
          cancelButtonText: this.$t('common.btn.cancel'),
          confirmButtonText: this.$t('common.btn.confirm'),
          type: 'warning'
        }).then(res => {
          let param = { id: this.selected[0].id }
          this.$store.dispatch('roleManagement/GET_DELETEBYID', param).then(response => {
            if (response.data.code == 200) {
              this.getRole()
              this.$message.success(this.$t('common.btn.deleteSuccess'))
            } else {
              this.$message.error(response.data.msg)
            }
          }).catch(error => { })
        }).catch(err => {

        })
    },
    // changeSort(item) {
    //   this.columns = [];
    //   this.$nextTick(function () {
    //     this.columns = item;
    //   });
    // },
    // ListSetting() {
    //   this.$refs.listSet.dialogVisible = true;
    // },
  },
};
